import { isEmpty } from 'lodash';
import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { Heading, StyledFlex, Text } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../translations';
import { PriceText } from '../price/PriceText';
import { TotalPriceText } from '../totalPrice/TotalPriceText';

import { VisitMedicalServiceTableBean } from './medicalServices.types';
import { getMedicalServicePrices } from './medicalServices.utils';

const StyledMedicalServicePriceText = styled(PriceText)`
   text-align: right;
`;

StyledMedicalServicePriceText.displayName = 'StyledMedicalServicePriceText';

const StyledPlaceholderText = styled(Text)`
   color: ${(props) => props.theme.placeholder};
`;

StyledPlaceholderText.displayName = 'StyledPlaceholderText';

type MedicalServiceListProps = {
   readonly medicalServices: VisitMedicalServiceTableBean[];
};

export const MedicalServiceList = (props: MedicalServiceListProps): JSX.Element => {
   return (
      <section>
         <Heading
            testId={'medicalServices'}
            type={'h3'}
            margin={'4px'}
            content={visitSettlementTranslationKeys.shared.medicalServices.list.heading}
            bold
         />
         {isEmpty(props.medicalServices) ? (
            <StyledPlaceholderText testId={'noMedicalServices'}>
               <Translate>{visitSettlementTranslationKeys.shared.medicalServices.list.placeholder}</Translate>
            </StyledPlaceholderText>
         ) : (
            <StyledFlex direction={'column'} gap={'12px'}>
               <StyledFlex direction={'column'} gap={'4px'}>
                  {props.medicalServices.map(({ medicalService, price }, index) => (
                     // eslint-disable-next-line react/no-array-index-key
                     <StyledFlex key={index} gap={'4px'} justifyContent={'space-between'} alignItems={'end'}>
                        <Text testId={'medicalServiceName'}>{medicalService.name}</Text>
                        <StyledMedicalServicePriceText testId={'price'} value={price!} stripDecimalZeroes />
                     </StyledFlex>
                  ))}
               </StyledFlex>
               <TotalPriceText prices={getMedicalServicePrices(props.medicalServices)} />
            </StyledFlex>
         )}
      </section>
   );
};
